module.exports = __webpack_public_path__ + "images/liinilaevad/routes/pointers/SOR-TRI-SOR.png";